module.exports = __webpack_public_path__ + "assets/webgl/Assets_1_base_color_L0.d8505fed.jpg";